import { Observable } from "rxjs";
import { take, shareReplay } from "rxjs/operators";

class ScriptLoaderService {
    private _scriptsLoaders: { [url: string]: Observable<Event> } = {};

    private doLoadScript(url: string, onBeforeLoad: () => void = null): Observable<Event> {
        return new Observable<Event>((observer) => {
            if(onBeforeLoad) {
                onBeforeLoad();
            }

            const script: HTMLScriptElement = document.createElement("script");

            script.onload = (event: Event): void => {
                observer.next(event);
                observer.complete();
            };

            script.onerror = (err): void => {
                observer.error(err);
            };

            script.src = url;

            const targetElement: HTMLElement = document.querySelector("head");
            targetElement.appendChild(script);
        });
    }

    public loadScript(url: string, onBeforeLoad: () => void = null): Observable<Event> {
        let targetLoader = this._scriptsLoaders[url];

        if(!targetLoader) {
            targetLoader = this.doLoadScript(url, onBeforeLoad).pipe(take(1), shareReplay(1));
            this._scriptsLoaders[url] = targetLoader;
        }

        return targetLoader;
    }
}

export const scriptLoaderService = new ScriptLoaderService();
